import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import sortSubmeasuresByPeriodAndGrade from '../../../features/probeDetails/reading/do/DecodingProbeDetailsMapper';
import { getSharedParserFormByMeasure } from '../shared/formsReducerParsers';

const { RAN, WR } = MEASURE;

const reformatRANFormData = form => ({
    uid: form.form_id,
    measure: form.measure,
    items: form.items.map(item => ({
        id: item.item_id,
        text: item.stimulus.text,
    })),
});

const parseQuestionDecodingData = (question, correctWordIds) => ({
    questionId: question.item_id,
    wordsOfQuestion: question.possible_responses.map(word => ({
        wordId: word.response_id,
        wordText: word.response_text,
        isCorrect: correctWordIds[question.item_id] === word.response_id,
    })),
});

const getGroupsOfQuestions = (questions, correctWordIds) =>
    questions.reduce((acc, question) => {
        const modifiedQuestion = parseQuestionDecodingData(question, correctWordIds);

        acc[question.word_type] = !acc[question.word_type]
            ? [modifiedQuestion]
            : [...acc[question.word_type], modifiedQuestion];

        return acc;
    }, {});

const reformatDecodingFormData = ({
    questions,
    correct_responses: correctWordIds,
    form_id: uid,
    grade_level: grade,
    period,
}) => ({
    uid,
    questions: sortSubmeasuresByPeriodAndGrade(
        getGroupsOfQuestions(questions, correctWordIds),
        period,
        grade,
    ),
});

const getForm = form => {
    switch (form.measure) {
        case RAN:
            return reformatRANFormData(form);
        // WR = DO, but we get WR measure from API Response, we will want to refactor it in future
        case WR:
            return reformatDecodingFormData(form);
        default:
            return getSharedParserFormByMeasure(form);
    }
};

export default getForm;
